import { immutableRecords } from "../../types";

const rectIntersectionFromPoint = (rect1, p1, p2) => {
  const SHRINK_AMOUNT = 2;

  // Test simple edge cases
  if (p1.x === p2.x) {
    // On same x-plane. Return that x position and top or bottom
    if (p1.y < p2.y) {
      // center of rect is above p2, so line will hit bottom
      return immutableRecords.PointRecord({
        x: p1.x,
        y: rect1.bottom - SHRINK_AMOUNT
      });
    } else {
      // Otherwise, line will hit top.
      return immutableRecords.PointRecord({
        x: p1.x,
        y: rect1.top + SHRINK_AMOUNT
      });
    }
  }
  if (p1.y === p2.y) {
    // On same y-plane. Return left or right, and that y position
    if (p1.x < p2.x) {
      // center of rect is left of p2, so line will hit right
      return immutableRecords.PointRecord({
        x: rect1.right - SHRINK_AMOUNT,
        y: p1.y
      });
    } else {
      // Otherwise, line will hit bottom.
      return immutableRecords.PointRecord({
        x: rect1.left + SHRINK_AMOUNT,
        y: p1.y
      });
    }
  }

  // If we reach here, need to do some intersection calcs
  const m = (p2.y - p1.y) / (p2.x - p1.x);

  if (p1.x < p2.x) {
    // rect is to the left, so only need to test right
    const y = m * (rect1.right - p1.x) + p1.y;
    if (y >= rect1.top && y <= rect1.bottom) {
      return immutableRecords.PointRecord({
        x: rect1.right - SHRINK_AMOUNT,
        y: y
      });
    }
  } else {
    // rect is to the right, so only need to test left
    const y = m * (rect1.left - p1.x) + p1.y;
    if (y >= rect1.top && y <= rect1.bottom) {
      return immutableRecords.PointRecord({
        x: rect1.left + SHRINK_AMOUNT,
        y: y
      });
    }
  }

  if (p1.y < p2.y) {
    // rect is to the top, so only need to test botttom
    const x = (rect1.bottom - p1.y) / m + p1.x;
    if (x >= rect1.left && x <= rect1.right) {
      return immutableRecords.PointRecord({
        x: x,
        y: rect1.bottom - SHRINK_AMOUNT
      });
    }
  } else {
    // rect is to the bottom, so only need to test top
    const x = (rect1.top - p1.y) / m + p1.x;
    if (x >= rect1.left && x <= rect1.right) {
      return immutableRecords.PointRecord({
        x: x,
        y: rect1.top + SHRINK_AMOUNT
      });
    }
  }

  // Should never reach here, but if we do, use the center
  return p1;
};

export default rectIntersectionFromPoint;
